import { jsx as _jsx } from "react/jsx-runtime";
import './style.css';
export var Divider = function (_a) {
    var width = _a.width;
    return (_jsx("div", { className: "divider", style: { width: width ? width : '100%' } }));
};
